import axios from 'axios';
import placeholder from '../data/placeHolderCopy';

const content = window.offers || placeholder;

export function init() {
  axios.interceptors.response.use((response) => response, // Do nothing with response data if successful
    () => {
      window.location.href = content.errorRedirectURL;
    });
}

export default init;
